import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import { User } from 'oidc-client-ts'
import { userManager } from '@/auth/oidcConfig'

interface OidcState {
	user: User | null
	loading: boolean
    error: string | null;
}

const initialState: OidcState = {
	user: null,
	loading: false,
    error: null,
}

export const loadUser = createAsyncThunk<User | null>(
	'oidc/load_user',
	async (_, { rejectWithValue }) => {
		try {
			const user = await userManager.getUser()
			if (user && !user.expired) {
				return user
			}
			return null
		} catch (err) {
			console.error('Failed to load user', err)
			return rejectWithValue('Failed to load user')
		}
	}
)

const oidcSlice = createSlice({
	name: 'oidc',
	initialState,
	reducers: {
		setUser: (state, action: PayloadAction<User | null>) => {
			state.user = action.payload
		},
	},
    extraReducers: (builder) => {
    builder
      .addCase(loadUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(loadUser.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.error = action.payload as string;
      });
  },
})

export const { setUser } = oidcSlice.actions
export default oidcSlice.reducer
